import React from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import styled from 'styled-components';
import { StyledTextField } from '../FormComponents';

const FormSection = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

const SectionTitle = styled(Typography)`
  color: #333;
  font-weight: 600;
  margin-bottom: 24px;
  font-family: "Montserrat", sans-serif;
  text-align: center;
`;

const PersonalDetailsStep = ({ formData, errors, onChange }) => {
  const countries = [
    "United States", "Canada", "United Kingdom", "Australia", "Germany", 
    "France", "Italy", "Spain", "Netherlands", "Sweden", "Norway", "Denmark",
    "Other"
  ];

  return (
    <FormSection>
      <SectionTitle variant="h6">Personal Details</SectionTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
          <StyledTextField
            type="text"
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={onChange}
            required
            error={!!errors.firstName}
            helperText={errors.firstName}
            sx={{ flex: 1 }}
          />
          <StyledTextField
            type="text"
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={onChange}
            required
            error={!!errors.lastName}
            helperText={errors.lastName}
            sx={{ flex: 1 }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
          <StyledTextField
            type="date"
            label="Date of Birth"
            name="dob"
            value={formData.dob}
            onChange={onChange}
            required
            error={!!errors.dob}
            helperText={errors.dob}
            InputLabelProps={{ shrink: true }}
            sx={{ flex: 1 }}
          />
          <FormControl
            variant="outlined"
            fullWidth
            required
            error={!!errors.gender}
            sx={{ flex: 1 }}
          >
            <InputLabel>Gender</InputLabel>
            <Select
              name="gender"
              value={formData.gender}
              onChange={onChange}
              label="Gender"
            >
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
              <MenuItem value="other">Other</MenuItem>
              <MenuItem value="prefer-not-to-say">Prefer not to say</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <FormControl
          variant="outlined"
          fullWidth
          required
          error={!!errors.country}
          sx={{ width: "100%" }}
        >
          <InputLabel>Country</InputLabel>
          <Select
            name="country"
            value={formData.country}
            onChange={onChange}
            label="Country"
          >
            {countries.map((country) => (
              <MenuItem key={country} value={country}>
                {country}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </FormSection>
  );
};

export default PersonalDetailsStep;
